import styled from 'styled-components';
import BGBanner from '../../../assests/images/bg-banner.webp';

export const ElliottAdvocacyBanner = styled.section`
    background-color:#ddf5f6;
    background-image:url(${BGBanner});
    padding:52px 0 125px 0;
    color: #333333;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 500;
    line-height: 26px;

    @media screen and (max-width: 1024px){ 
        padding-top: 150px;
    }

    @media screen and (max-width: 767px){ 
        padding-top: 130px;
    }

    @media screen and (max-width: 575px){ 
        font-size:16px;
        line-height: 24px;
    }

    &.career-banner-sec{
        @media screen and (max-width: 1024px){ 
            padding-top: 170px;
        }
    }
    &.elliott-advocacy-banner{
        @media screen and (max-width: 1024px){ 
            padding-top: 160px;
        }
    }
`;
export const AdvocacyTitle = styled.h1`
    color:#01606F; 
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight:700;
    line-height: 60px;
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        font-size: 36px;
        line-height: 56px;
    }

    @media screen and (max-width: 767px){
        font-size: 32px;
        line-height: 54px;
    }

    @media screen and (max-width: 575px){
        font-size: 30px;
        line-height: 50px;
    }
    
    @media screen and (max-width: 480px){
        font-size: 26px;
        line-height: 40px;
    }
`;

export const AdvocacyText = styled.p`
    margin-bottom: 30px;
`;
